import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LangEnum } from '@models/enums';
import type { RootState } from '@store/root-reducer';

export const useVerificationUrl = () => {
    const { i18n } = useTranslation();
    const verificationUrl =
        useSelector((state: RootState) => state.docsVerification.sdkOptions?.verificationUrl) || '';

    const urlWithLang = useMemo(() => {
        if (i18n.language === LangEnum.EN) {
            return verificationUrl;
        }

        const url = new URL(window.location.href);

        url.searchParams.set('lang', i18n.language);

        return url.toString();
    }, [i18n.language, verificationUrl]);

    return {
        verificationUrl: urlWithLang,
    };
};
